import React, { useState, useEffect } from "react";
import { $ } from "../../../../../vendor";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import ProductsProductsSelect from "./ProductsProductsSelect";
import ProductsPricetariffs from "./ProductsPricetariffs";

import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";

import {
  productsActions,
  alertsActions,
  fileManagerActions,
  productsSelectors,
  useSelector,
} from "inbooma-api";
import { S3Client } from "aws_js";
import { getApiHost } from "../../../../Sync";
import { base64ToJson, getItem, in_array, jsonToBase64 } from "../../../../utils/Helper";
import * as FileSaver from "../../../../../vendor/FileSaver";
import ImageUpload from "../../../components/ImageUpload";
import LocationsChange from "../../contingents/components/behaviors/LocationsChange";

// import { rbac } from './index';
// @todo Implement rbac, if necessary (right now view is only accessible by admin)
// @todo style select list https://react-select.com/styles

let editedEntity = {}; // === The body of PATCH /product/xy, initialized further down

const ItemView = (props) => {
  const [contingent, setContingent] = useState(props.contingent);
  const [product, setProduct] = useState(
    props.selectedProduct !== null
      ? { ...props.selectedProduct, _image: props.selectedProduct.image }
      : {
          name: contingent !== null ? contingent.name : "",
          description: contingent !== null ? contingent.description : "",
          layout_type: "",
          contingents:
            contingent !== null
              ? typeof contingent.id !== "undefined" && contingent.id
                ? [contingent]
                : [{ id: null, name: contingent.name }]
              : [],
          pricetariffs: [],
          locations: [],
          products_products: [],
          related_products: [],
          client_id: Number(Biscuit.get("user.client_id")),
          image: contingent !== null ? contingent.image : "",
          id: "",
          UVP: "",
          parent_id: 153,
          deposit: "",
          contingentsForSelect: [],
          locationsForSelect: [],
          model: "",
          type: "",
          fe_visible: contingent !== null ? contingent.fe_visible : true,
          discountable: false,
          _requiredProducts: [],
          _products: [],
          _image: contingent !== null ? contingent.image : "",
        },
  );
  const [image, setImage] = useState(product.image);
  let language = Biscuit.get("user.lang").replace("_", "-");

  useEffect(() => {
    if (image === "") {
      return;
    }
    let clone = {};
    Object.assign(clone, product);
    clone.image = image;
    setProduct(clone);
    editedEntity["image"] = image;
    setEntityWasEdited(productWasEdited + 1);
  }, [image]);

  const onSubmit = () => {
    // proof for empty fields
    // ...
    // submit form
    if (product.locations.length > 0) {
      let productItems = [];
      if (product.product_items.length > 0) {
        product.product_items.map((item) => {
          if (item.model === "Locations") {
            productItems.push(item.foreign_key);
          }
        });
      }
      product.locations.map((item) => {
        if (!in_array(item.id, productItems)) {
          let set = {
            model: "Locations",
            foreign_key: item.id,
          };
          if (product.id !== "") {
            set["product_id"] = product.id;
          }
          product.product_items.push({
            set,
          });
        }
      });
    }
    if (product.name !== "" && product.name !== null) {
      props.dispatch(
        productsActions.postProduct({
          body: {
            name: product.name,
            client_id: Number(Biscuit.get("user.client_id")),
            description: product.description,
            contingents: product.contingents,
            locations: product.locations,
            related_products: product.related_products,
            parent_id: product.parent_id,
            UVP: product.UVP,
            image: product.image,
          },
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setItemState("saving");
      //abortButtonRef.current.click();
      //props.onClose();
    }
  };

  const [initialized, setInitializeState] = useState(false);

  const _initialize = () => {
    if (typeof product.id !== "undefined") {
      const id = product.id;
      let contingentValues = [],
        locationValues = [];
      contingentValues.push({ value: null, label: t("all") });
      locationValues.push({ value: null, label: t("all") });
      let clone = {};
      Object.assign(clone, product);
      props.contingents.forEach(function (value, key) {
        if (typeof product.contingents !== "undefined") {
          product.contingents.forEach(function (subValue, subKey) {
            if (subValue.id === value.id) {
              let _helper = new Array();
              _helper["value"] = subValue.id;
              _helper["label"] = value.name;
              contingentValues.push(_helper);
            }
          });
        }
      });
      /*  props.locations.forEach(function (value, key) {
                if (typeof product.locations !== 'undefined') {
                    product.locations.forEach(function (subValue, subKey) {
                        if (subValue.id === value.id) {
                            let _helper = new Array();
                            _helper['value'] = subValue.id;
                            _helper['label'] = value.name;
                            locationValues.push(_helper);
                        }
                    })
                }
            })*/
      if (typeof product.products_products !== "undefined") {
        let _requiredProducts = [];
        let _products = [];
        product.products_products.forEach(function (value, key) {
          if (typeof product.related_products !== "undefined") {
            product.products.forEach(function (subValue, subKey) {
              if (subValue.id === value.related_product_id) {
                if (value.required) {
                  _requiredProducts.push(subValue);
                } else {
                  _products.push(subValue);
                }
              }
            });
          }
        });
        clone._requiredProducts = _requiredProducts;
        clone._products = _products;
      }

      clone.contingentsForSelect = contingentValues;
      clone.locationsForSelect = locationValues;

      setProduct(clone);
    }
    setInitializeState(true);
  };

  if (!initialized) {
    _initialize();
  }

  let _helper = [],
    layout_helper = [],
    types = [];
  const [parentId, setParentId] = useState(
    typeof product.parent_id === "" ? 153 : product.parent_id,
  );
  types[153] = t("contingents_product", null, "capital");
  types[154] = t("extra option", null, "capital");
  _helper["value"] = parentId;
  _helper["label"] = types[parentId];

  let helpType = [];
  let FileName = "";
  helpType.push(_helper);
  const [layoutType, setLayoutType] = useState(
    product.layout_type === "" ? "checkbox" : product.layout_type,
  );
  let layout_types = [
    t("checkbox", null, "capital"),
    t("selectbox", null, "capital"),
    //t('textbox_number',null,'capital'),
    // //t('textbox_text',null,'capital')
  ];
  let layout_object = {
    checkbox: t("checkbox", null, "capital"),
    selectbox: t("selectbox", null, "capital"),
    //    'textbox_number' : t('textbox_number',null,'capital'),
    //    'textbox_text' : t('textbox_text',null,'capital')
  };
  layout_helper["value"] = layoutType;
  layout_helper["label"] = layout_object[layoutType];
  let layout_help_types = [
    "checkbox",
    "selectbox",
    //'textbox_number',
    // //'textbox_text'
  ];
  let helpLayoutType = [];
  helpLayoutType.push(layout_helper);

  const [selectedLayoutType, setSelectedLayoutType] = useState(helpLayoutType);
  const [selectedType, setSelectedType] = useState(helpType);
  const [productNameEditMode, setEntityNameEditMode] = useState(false);
  const [productWasEdited, setEntityWasEdited] = useState(0); // Mutable integer ensuring re-render
  const [imageFile, setImageFile] = useState(null);
  const [itemState, setItemState] = useState("init"); // init, saving

  const _products = useSelector((state) => state.products_data); // used for after save process
  const _addProduct = useSelector((state) => state.products_data.postProduct);
  const _patchProduct = useSelector((state) => state.products_data.patchProduct);

  useEffect(() => {
    if (_addProduct.success === "" || itemState !== "saving") {
      return;
    }
    if (_addProduct.success === true) {
      if (contingent !== null) {
        let clone = getItem("contingent", true);
        clone.products = [{ id: _addProduct?.data?.id, name: _addProduct?.data?.name }];
        if (clone.description === null || clone.description === "") {
          clone.description = _addProduct?.data?.description;
        }
        props.onExit(null, clone);
      } else {
        props.showNotification("success", _addProduct.data.id);
        props.onExit();
      }
    } else {
      props.showNotification("warning", 0);
    }
  }, [_addProduct]);

  useEffect(() => {
    if (_patchProduct.success === "" || itemState !== "saving") {
      return;
    }
    if (_patchProduct.success === true) {
      if (contingent !== null) {
        let clone = getItem("contingent", true);
        clone.products = [{ id: _patchProduct?.data?.id, name: _patchProduct?.data?.name }];
        if (clone.description === null || clone.description === "") {
          clone.description = _addProduct?.data?.description;
        }
        props.onExit(null, clone);
      } else {
        props.showNotification("success", _patchProduct.data.id);
        props.onExit();
      }
    } else {
      props.showNotification("warning", 0);
    }
  }, [_patchProduct]);

  /*useEffect(() => {
        console.log("use effect products: ",_products);
        // the state somehow is one event behind, e.g. new created products are not part of the products array this time
        if (_products.products.success === "") {            // true or false no matter if a new item is created or an existing item modified
            return;
        }

        if (itemState !== 'saving') return;

        var isNewItem = (document.location.href.indexOf('add') >= 0);
        if(contingent !== null) {
            let clone = {};
            Object.assign(clone,contingent);
            if (isNewItem) {

                if (_products.products.success === true) {
                    clone.products.push(_products.products.data[_products.products.data.length-1]);
                    props.onExit(jsonToBase64(clone));
                   // props.showNotification('success', _products.products.data[_products.products.data.length-1].id);
                }

                if (_products.products.success === false) {
                    props.showNotification('warning', 0);
                }
            } else {

                if (_products.products.success === true) {
                    clone.products.push(props.entity);
                    props.onExit(jsonToBase64(clone));
                   // props.showNotification('success',props.entity.id);
                }

                if (_products.products.success === false) {
                    props.showNotification('warning', props.entity.id);
                }
            }
            props.setContingent(jsonToBase64(clone));
        } else {
            if (isNewItem) {

                if (_products.products.success === true) {
                    props.showNotification('success', _products.products.data[_products.products.data.length-1].id);
                }

                if (_products.products.success === false) {
                    props.showNotification('warning', 0);
                }
            } else {

                if (_products.products.success === true) {
                    props.showNotification('success',props.entity.id);
                }

                if (_products.products.success === false) {
                    props.showNotification('warning', props.entity.id);
                }
            }
            abortButtonRef.current.click();
        }

        // close window

    }, [_products]);*/

  /**
   * Recursively checks for any products in any child product
   *
   * @param {Object} product
   * @return {bool}
   */
  const productHasAnyChildProduct = (product) => {
    let result = false;

    if (typeof product.related_products !== "undefined" && product.related_products.length >= 1) {
      result = true;
    }

    if (!result && typeof product.child_products !== "undefined") {
      product.child_products.forEach((_product) => {
        if (!productHasAnyChildProduct(_product)) {
          result = true;
          return;
        }
      });
    }

    return result;
  };

  /*const readFile = (event) =>
    {
       const file = {
           name: FileName,
           body: event.target.result,
           type: 'png'
       };
       console.log('file',file);
        S3Client.addImage(file,'product',Biscuit.get('user.client_id'))
            .then(data => {
                 console.log(data);

            })
            .catch(err => {
                alert('Could not upload: ' + err);
            });

        editedEntity['image'] = {
            'name': FileName,
            'blob': event.target.result
        };


        let clone = {};
        Object.assign(clone, product);
        clone.image = editedEntity['image'];
        clone._image = FileName;
        setProduct(clone);
    };

    const uploadFile = (file) => {
        FileName = file.name;
        var image = document.createElement('img');
        let reader = new FileReader();
        reader.addEventListener('loadend',()=>{
            let contents=reader.result;
            image.src = contents;
            $('#image').html(image);
        })
        /!*reader.addEventListener('load', readFile);
        reader.readAsDataURL(file)*!/;

         S3Client.addImage(file,'product',Biscuit.get('user.client_id'))
             .then(function() {
                 editedEntity['image'] = `https://client-${Biscuit.get('user.client_id')}-docs.s3.eu-central-1.amazonaws.com/Images/product_` + file.name;
                 let clone = {};
                 Object.assign(clone, product);
                 clone.image = `https://client-${Biscuit.get('user.client_id')}-docs.s3.eu-central-1.amazonaws.com/Images/product_` + file.name;
                 setProduct(clone);
             })
             .catch(err => {

                 console.log('CATCH S3 UPLOAD', err);
                 alert('S3 Upload failed: ' + err);


             });
    }

    const onUploadFile = (e) => {
        const files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            uploadFile(files[i]);
        }
        setEntityWasEdited(productWasEdited+1);

    }
*/
  const patchEntity = () => {
    let clone = {};
    let fieldsToClear = ["UVP", "deposit", "layout_type", "name", "description", "model"];
    Object.assign(clone, product);
    if (typeof clone.fe_visible === "string") {
      clone.fe_visible = clone.fe_visible === "true";
    }
    clone.products = [];
    Object.keys(clone).map((key) => {
      console.log(key, "key");
      console.log(typeof clone[key], "value");
      if (in_array(key, fieldsToClear) && clone[key] === "") {
        clone[key] = null;
      }
      console.log(typeof clone[key], "value");
    });
    clone._requiredProducts.forEach(function (value, key) {
      if (typeof value.id !== "undefined") {
        clone.products_products.push({
          product_id: clone.id,
          related_product_id: value.id,
          required: 1,
        });
      } else {
        clone.products_products.push({
          product_id: clone.id,
          related_product_id: value.value,
          required: 1,
        });
      }
    });
    clone._products.forEach(function (value, key) {
      if (typeof value.id !== "undefined") {
        clone.products_products.push({
          product_id: clone.id,
          related_product_id: value.id,
          required: 0,
        });
      } else {
        clone.products_products.push({
          product_id: clone.id,
          related_product_id: value.value,
          required: 0,
        });
      }
    });
    let newVal = [];
    let productItems = [];
    if (typeof clone.contingents !== "undefined" && clone.contingents.length > 0) {
      clone.contingents.forEach(function (value, key) {
        newVal.push({ id: value.id, name: value.name });
        productItems.push({ foreign_key: value.id });
      });
      //clone.contingents = newVal;
      delete clone.contingents;
    }
    if (typeof clone.locations !== "undefined" && clone.locations.length > 0) {
      product.locations.map((item) => {
        newVal.push({ id: item.id, name: item.name });
        productItems.push({ foreign_key: item.id, model: "Locations" });
      });
      delete clone.locations;
    }
    if (productItems.length > 0) {
      clone.product_items = productItems;
    }
    delete clone._requiredProducts;
    delete clone._products;
    //delete clone.related_products;
    delete clone.pricetariffs;
    delete clone.parent_product;
    delete clone.linkable_products;
    if (contingent !== null && (typeof contingent.id === "undefined" || contingent.id === null)) {
      delete clone.contingentsForSelect[0];
    }
    if (clone.parent_id === 153 && clone.product_items.length < 1 && contingent === null) {
      props.dispatch(
        alertsActions.addAlert({
          message: t("at_minimum_one_contingent_required"),
          icon: "fi fi-alert",
        }),
      );
      return false;
    }
    /*if(clone.layout_type !== ''){
            clone.layout_type = layout_types[clone.layout_type];
        }*/
    /*
                const callback = (response) => {
                    if (response.success) {
                        if(product.id !== '') {
                            props.dispatch(alertsActions.addAlert({
                                message: t('updated_${a}', {a: t('product')}, 'capital'),
                                icon: 'fi fi-check',
                            }));
                        } else {
                            props.dispatch(alertsActions.addAlert({
                                message: t('added_${a}', {a: t('product')}, 'capital'),
                                icon: 'fi fi-check',
                            }));
                            let link = '/products/' + response.data.id;
                            $('#resetLink').attr('href',link);
                            $('#resetLink').click();
                        }
                    } else {
                        props.dispatch(alertsActions.addAlert({
                            message : t('request_error'),
                            icon : 'fi fi-alert',
                        }));
                    }
                };
        */
    if (product.id !== "") {
      props.dispatch(
        productsActions.patchProduct({
          id: Number(product.id),
          token: Biscuit.get("token"),
          //callback,
          body: {
            ...clone,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );

      //abortButtonRef.current.click();
      //props.onClose();
    } else {
      props.dispatch(
        productsActions.postProduct({
          body: {
            ...clone,
          },
          //callback,
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );

      //abortButtonRef.current.click();
      //props.onClose();
    }
    setItemState("saving");

    // setEntityWasEdited(0);
  };

  const onChangeProductContingents = (contingents) => {
    if (contingents === null) {
      editedEntity["contingents"] = [];
      let clone = {};
      Object.assign(clone, product);
      clone.contingents = [];
      clone.contingentsForSelect = [];
      setProduct(clone);
      setEntityWasEdited(productWasEdited + 1);
      return;
    }
    editedEntity["contingents"] = contingents.map((contingent) => {
      return { id: contingent.value };
    });
    product.contingents = contingents.map((contingent) => {
      return { id: contingent.value };
    });
    let clone = {};
    Object.assign(clone, product);
    clone.contingents = contingents.map((contingent) => {
      return { id: contingent.value };
    });
    clone.contingentsForSelect = contingents;
    setProduct(clone);
    setEntityWasEdited(productWasEdited + 1);
  };

  const onChangeProducts = (products) => {
    if (products === null || products.length === 0) {
      editedEntity["products"] = [];
      let clone = {};
      Object.assign(clone, product);
      clone._requiredProducts = [];
      clone.related_products = [];
      clone.products_products = [];
      setProduct(clone);
      setEntityWasEdited(productWasEdited + 1);
      return;
    }
    products.forEach(function (value, key) {
      value.required = 1;
    });
    editedEntity["products"] = products.map((product) => {
      return { id: product.value };
    });
    product._requiredProducts = products;
    let clone = {};
    Object.assign(clone, product);
    clone._requiredProducts = products;
    setProduct(clone);
    setEntityWasEdited(productWasEdited + 1);
  };

  const onChangeProductsWithOutRequired = (products) => {
    if (products === null || products.length === 0) {
      editedEntity["products"] = [];
      let clone = {};
      Object.assign(clone, product);
      clone._products = [];
      setProduct(clone);
      setEntityWasEdited(productWasEdited + 1);
      return;
    }
    editedEntity["products"] = products.map((product) => {
      return { id: product.value };
    });
    products.forEach(function (value, key) {
      value.required = 0;
    });
    product._products = products;
    let clone = {};
    Object.assign(clone, product);
    clone._products = products;
    setProduct(clone);
    setEntityWasEdited(productWasEdited + 1);
  };

  const onChangeType = (e) => {
    editedEntity["parent_id"] = e.target.value;
    product.parent_id = e.target.value;
    setParentId(e.target.value);
    let clone = {};
    Object.assign(clone, product);
    clone.parent_id = e.target.value;
    if (e.target.value == 154) {
      clone.model = "ExtraOption";
    } else {
      clone.model = "Bike";
    }
    setProduct(clone);
    setEntityWasEdited(productWasEdited + 1);
  };

  const onChangeLayoutType = (type) => {
    editedEntity["layout_type"] = type.value;
    product.layout_type = type.value;
    setLayoutType(type.value);
    setSelectedLayoutType(type);
    let clone = {};
    Object.assign(clone, product);
    clone.layout_type = type.value;
    setProduct(clone);
    setEntityWasEdited(productWasEdited + 1);
  };

  const onChangeForm = (e) => {
    setEntityWasEdited(productWasEdited + 1);
    let clone = {};
    Object.assign(clone, product);
    editedEntity[e.target.name] = e.target.value;
    if (e.target.id === "image_input__reset") {
      clone.image = e.target.value;
      clone._image = e.target.value;
      setImage(e.target.value);
    }
    switch (e.target.name) {
      case "name":
        clone.name = e.target.value;
        break;
      case "description":
        clone.description = e.target.value;
        break;
      case "UVP":
        clone.UVP = e.target.value;
        break;
      case "deposit":
        clone.deposit = parseFloat(e.target.value);
        break;
      case "type":
        clone.type = e.target.value;
        break;
      case "fe_visible":
        clone.fe_visible = e.target.checked;
        break;
      case "discountable":
        clone.discountable = e.target.checked;
        break;
      case "_image":
        clone.image = e.target.value;
        clone._image = e.target.value;
        setImage(e.target.value);
        break;
    }
    setProduct(clone); // set object state
  };

  const abortButtonRef = React.createRef();
  const resetButtonRef = React.createRef();

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"></div>
      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        data-close-on-click="false"
        aria-hidden="false"
      >
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
          <h1 className="inb-page-title">
            {typeof product.id !== "undefined" && product.id !== ""
              ? t("edit_${a}", { a: t("product", null, "capital") })
              : t("add_${a}", { a: t("product", null, "capital") })}
          </h1>

          <div className="off-canvas__actions column">
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title={t("save")}
              onClick={() => patchEntity()}
            >
              {itemState == "init" && (
                <>
                  <i className="fi fi-check"></i>
                  <span>{t("save")}</span>
                </>
              )}
              {itemState == "saving" && (
                <span>
                  <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                  {t("save")}
                </span>
              )}
            </button>
            <a href="#">
              <button
                type="button"
                ref={abortButtonRef}
                className="button hollow secondary right button-abort round"
                title={t("close_window")}
                onClick={() => props.onExit()}
              >
                <i className="fi fi-x"></i>
              </button>
            </a>
            <a id="resetLink" href="" style={{ display: "none" }}>
              <button
                type="button"
                ref={resetButtonRef}
                id="inb-productsform-reset-button"
                className="button hollow secondary right button-abort round"
                title="Fenster schließen"
              >
                <i className="fi fi-x"></i>
              </button>
            </a>
          </div>
        </header>

        <form className="off-content row">
          <div className="inb-form-group column medium-6 small-12 lang">
            <label className="inb-form__controlLabel">{t("name", null, "capital")}</label>
            <div className="inb-form__controllClass">
              <input
                type="text"
                className="form-control"
                name="name"
                autoComplete="false"
                maxLength="255"
                value={product.name}
                onChange={onChangeForm}
                placeholder=""
              />
            </div>
          </div>

          <div className="inb-form-group column medium-6 small-12 lang">
            <label className="inb-form__controlLabel">{t("description", null, "capital")}</label>
            <div className="inb-form__controllClass">
              <textarea
                className="form-control"
                name="description"
                autoComplete="false"
                value={product.description}
                onChange={onChangeForm}
                placeholder=""
              />
            </div>
          </div>

          <ImageUpload
            onChange={onChangeForm}
            image={product.image}
            type="product"
            clientId={Biscuit.get("user.client_id")}
            setImage={setImage}
            dispatch={props.dispatch}
          />

          <div className="inb-form-group column medium-6 small-12 lang">
            <label className="inb-form__controlLabel">{t("category", null, "capital")}</label>
            <div className="inb-form__controllClass">
              <input
                className="form-control"
                name="type"
                autoComplete="false"
                value={product.type}
                onChange={onChangeForm}
                placeholder=""
              />
            </div>
          </div>
          <div className="inb-form-group column medium-6 small-12 lang">
            <div className="inb-form__controllClass">&nbsp;</div>
          </div>
          {/* <div className="inb-form-group-column medium-6 small-12 lang">
                        <label
                            htmlFor="upload-file-input"
                            className="inb-form__controlLabel"
                            style={{fontSize:'.85rem',fontWeight:'normal', padding:"0 1rem"}}>
                            <a>
                                 Left the href="#" out by purpose: fileInput wouldn't get called
                                <i className="fi fi-page-add product-icon"></i>
                                + {t('add_${a}',{a:t('image')})}
                            </a>
                        </label>
                        <input
                            id="upload-file-input"
                            className="form-control"
                            name="upload-file-input"
                            type="file"
                            style={{position: 'fixed', top: '-100em'}}
                            onChange={onUploadFile}
                        />
                        <div style={{display:"block",width:"100%"}}>
                            <span style={{float:"left",padding:"5px 0 5px 1rem"}}>{t('link',null,'capital')}:</span>
                            <input type="text" className="form-control" name="_image" onChange={onChangeForm} style={{float:"left", width:"90%"}} value={product._image}/>
                        </div>
                    </div>

                    <div className="inb-form-group column medium-6 small-12 lang">
                        <label className="inb-form__controlLabel">{t('preview',null,'capital')}</label>
                        <div id="image" className="inb-form__controllClass">
                            {product.image !== '' && <img src={product.image}/>}
                        </div>
                    </div>*/}

          <div className="inb-form-group column medium-3 small-6_rate">
            <label className="inb-form__controlLabel">{t("visible as", null, "capital")}</label>
            <div className="inb-form__controllClass">
              <input
                type="radio"
                className="form-control"
                id="radio1"
                name="extension_possible"
                value="153"
                checked={product.parent_id == 153}
                placeholder=""
                onChange={(e) => onChangeType(e)}
              />
              <label htmlFor="radio1"> {types[153]}</label>
            </div>
          </div>

          <div className="inb-form-group column medium-3 small-6_rate">
            <label className="inb-form__controlLabel">&nbsp;</label>
            <div className="inb-form__controllClass">
              <input
                type="radio"
                className="form-control"
                id="radio2"
                name="extension_possible"
                value="154"
                checked={product.parent_id == 154}
                placeholder=""
                onChange={(e) => onChangeType(e)}
              />
              <label htmlFor="radio2"> {types[154]}</label>
            </div>
          </div>

          {/*<div className="inb-form-group column medium-6 small-12 lang">
                        <label className="inb-form__controlLabel">{t('type',null,'capital')}</label>
                        <div className="inb-form__controllClass">
                            <Select
                                className="form-control"
                                name="parent_id"
                                value={selectedType}
                                onChange={onChangeType}
                                options={types.map((option, idx) => ({label: option, value: idx}))}
                            />                        </div>
                    </div>*/}

          <div className="inb-form-group column medium-3 small-6 lang">
            <label className="inb-form__controlLabel">&nbsp;</label>
            <div className="inb-form__controllClass">
              <input
                type="checkbox"
                id="pt1"
                className="form-control"
                name="fe_visible"
                autoComplete="false"
                maxLength="255"
                checked={product.fe_visible}
                onChange={onChangeForm}
                placeholder=""
              />
              <label htmlFor="pt1">{t("fe_visible_product", null, "capital")}</label>
            </div>
          </div>
          <div className="inb-form-group column medium-2 small-4 lang">
            <label className="inb-form__controlLabel">&nbsp;</label>
            <div className="inb-form__controllClass">
              <input
                type="checkbox"
                id="pt2"
                className="form-control"
                name="discountable"
                autoComplete="false"
                maxLength="255"
                checked={product.discountable}
                onChange={onChangeForm}
                placeholder=""
              />
              <label htmlFor="pt2">{t("discountable", null, "capital")}</label>
            </div>
          </div>

          {product.parent_id == 154 && (
            <div className="inb-form-group column medium-6 small-12 lang">
              <label className="inb-form__controlLabel">{t("layout_type", null, "capital")}</label>
              <div className="inb-form__controllClass">
                <Select
                  className="form-control"
                  name="parent_id"
                  value={selectedLayoutType}
                  onChange={onChangeLayoutType}
                  options={layout_types.map((option, idx) => ({
                    label: option,
                    value: layout_help_types[idx],
                  }))}
                />{" "}
              </div>
            </div>
          )}

          <div className="inb-form-group column medium-12 small-12 lang">
            <label className="inb-form__controlLabel">{t("contingents", null, "capital")}</label>
            <span className="inb-form__controlLabel size-12">
              {t("product_contingents_help", null, "capital")}
            </span>

            <div className="inb-form__controllClass">
              <Select
                className="form-control"
                name="contingents"
                value={product.contingentsForSelect} //{typeof product.contingents === 'undefined' ? [] : product.contingents.map(contingent => typeof contingent.id !== 'undefined' ? { value: contingent.id, label: contingent.name } : [])}
                isMulti="true"
                onChange={onChangeProductContingents}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "3px",
                  colors: {
                    ...theme.colors,
                    primary25: "#EB6A3A",
                    primary: "#EB6A3A",
                  },
                })}
                placeholder={t("select_${a}", { a: t("contingent") })}
                options={props.contingents.map((contingent) => {
                  return { value: contingent.id, label: contingent.name };
                })}
              />
            </div>
          </div>

          <LocationsChange
            contingent={product}
            setContingent={setProduct}
            dispatch={props.dispatch}
          />

          {typeof product.id !== "undefined" && product.id !== "" && (
            <ProductsProductsSelect
              product={product}
              parentId={parentId}
              onChangeProducts={onChangeProducts}
              onChangeProductsWithOutRequired={onChangeProductsWithOutRequired}
            />
          )}

          <div className="inb-form-group column medium-6 small-12 lang">
            <label className="inb-form__controlLabel">{t("UVP", null, "capital")}</label>
            <div className="inb-form__controllClass">
              <input
                className="form-control"
                type="text"
                name="UVP"
                autoComplete="false"
                maxLength="255"
                value={product.UVP}
                onChange={onChangeForm}
                placeholder=""
                style={{ float: "left" }}
              />
              <span style={{ marginLeft: "-8%", paddingTop: "1%", display: "inline-block" }}>
                {Biscuit.get("client.currency")}
              </span>
            </div>
          </div>
          <div
            className="inb-form-group column medium-6 small-12 lang"
            style={{ visibility: "hidden" }}
          >
            <label className="inb-form__controlLabel">{t("deposit", null, "capital")}</label>
            <div className="inb-form__controllClass">
              <input
                className="form-control"
                type="text"
                name="deposit"
                autoComplete="false"
                maxLength="255"
                value={product.deposit}
                onChange={onChangeForm}
                placeholder=""
                style={{ float: "left" }}
              />
              <span style={{ marginLeft: "-8%", paddingTop: "1%", display: "inline-block" }}>
                {Biscuit.get("client.currency")}
              </span>
            </div>
          </div>
          {typeof product.id !== "undefined" && product.id !== "" && (
            <ProductsPricetariffs
              product={product}
              pricetariffs={product.pricetariffs}
              dispatch={props.dispatch}
            />
          )}
        </form>
      </div>
    </>
  );
};

export default ItemView;
